import React from 'react';
import { Item } from './styles';

export const DndList = ({ children }) => {
  return <>{children}</>;
};

DndList.Item = function DndListItem({
  children,
  total,
  number,
  color_l2 = null,
  isOnDrag = null,
  isActive = null,
  deletePrompt = null,
  parentType = 'manual',
  forType = 'List',
  ...restProps
}) {
  return (
    <Item
    deletePrompt={deletePrompt}
      total={total}
      number={number}
      color_l2 ={color_l2}
      isOnDrag={isOnDrag}
      forType={forType}
      parentType = {parentType}
      isActive={isActive}
      {...restProps}
    >
      {children}
    </Item>
  );
};
